import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-29b31682"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "thumbs" }
const _hoisted_2 = ["disabled"]
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  fill: "none",
  height: "24",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  width: "24",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M14 9V5a3 3 0 0 0-3-3l-4 9v11h11.28a2 2 0 0 0 2-1.7l1.38-9a2 2 0 0 0-2-2.3zM7 22H4a2 2 0 0 1-2-2v-7a2 2 0 0 1 2-2h3" })
], -1))
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = ["disabled"]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M10 15v4a3 3 0 0 0 3 3l4-9V2H5.72a2 2 0 0 0-2 1.7l-1.38 9a2 2 0 0 0 2 2.3zm7-13h2.67A2.31 2.31 0 0 1 22 4v7a2.31 2.31 0 0 1-2.33 2H17" })
], -1))
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = {
  key: 0,
  class: "feedback-text"
}
const _hoisted_9 = ["disabled"]
const _hoisted_10 = {
  key: 1,
  class: "submitted-feedback"
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Feedback:", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("button", {
        class: _normalizeClass(["thumb", { clicked: _ctx.clickedThumb === 'up' }]),
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onThumbUp && _ctx.onThumbUp(...args))),
        disabled: _ctx.clickedThumb !== null
      }, _hoisted_4, 10, _hoisted_2),
      _createElementVNode("button", {
        class: _normalizeClass(["thumb", { clicked: _ctx.clickedThumb === 'down' }]),
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onThumbDown && _ctx.onThumbDown(...args))),
        disabled: _ctx.clickedThumb !== null
      }, _hoisted_7, 10, _hoisted_5)
    ]),
    (_ctx.clickedThumb !== null)
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
          (!_ctx.feedbackSubmitted)
            ? (_openBlock(), _createElementBlock("form", {
                key: 0,
                class: "feedback-form",
                onSubmit: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onSubmitFeedback && _ctx.onSubmitFeedback(...args)), ["prevent"]))
              }, [
                _withDirectives(_createElementVNode("textarea", {
                  rows: "2",
                  cols: "20",
                  class: "user-feedback",
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.feedbackText) = $event)),
                  placeholder: "Any additional feedback will help improve the service."
                }, null, 512), [
                  [_vModelText, _ctx.feedbackText]
                ]),
                _createElementVNode("button", {
                  type: "submit",
                  class: "feedback-submit-button",
                  disabled: !_ctx.feedbackText.trim()
                }, " Submit ", 8, _hoisted_9)
              ], 32))
            : (_openBlock(), _createElementBlock("div", _hoisted_10, [
                _hoisted_11,
                _createTextVNode(" " + _toDisplayString(_ctx.feedbackText), 1)
              ]))
        ]))
      : _createCommentVNode("", true)
  ], 64))
}